<!-- ZONES PRIMENG DATATABLE -->
<p-table [value]="paginationResult.entities"
  [lazy]="true"
  (onLazyLoad)="loadData($event)"
  [rows]="paginationRequest.pageSize"
  [totalRecords]="paginationResult.filteredEntities"
  [rowsPerPageOptions]="[10,20,30,40,50]"
  [paginator]="true"
  [(selection)]="selectedEntities"
  [loading]="loading"
  [rowHover]="true"
  [showCurrentPageReport]="true"
  currentPageReportTemplate=
  "{first} - {last} {{ 'table.of' | translate }} {totalRecords}"
  class="custom-table"
  styleClass="p-datatable-striped"
  >

  <!-- TABLE TITLE DEFINITION -->
  <ng-template pTemplate="caption">
    <div class="d-flex align-items-center justify-content-center text-uppercase mb-5 table-title">
      {{ 'control-panel.zone-groups.zonesTable' | translate }}
    </div>
  </ng-template>

  <!-- TABLE COLUMN DEFINITION -->
  <ng-template pTemplate="header">
    <tr>

      <!-- SELECT -->
      <th class="checkbox-column">
        <div class="d-flex justify-content-center">
          <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
        </div>
      </th>

      <!-- ID -->
      <th>
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            ID
          </div>

        </div>
      </th>

      <!-- NAME -->
      <th pSortableColumn="name">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'general.name' | translate }}
          </div>

          <!-- COLUMN SORT ICON -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="name"></p-sortIcon>
          </div>

        </div>
      </th>

      <!-- TYPE -->
      <th pSortableColumn="circular">
        <div class="d-flex align-items-center h-100">

          <!-- COLUMN TITLE -->
          <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
            {{ 'general.type' | translate }}
          </div>

          <!-- COLUMN SORT ICON -->
          <div class="d-flex align-items-center h-100">
            <p-sortIcon field="circular"></p-sortIcon>
          </div>

        </div>
      </th>

      <!-- EVENT ON ENTER -->
      @if (!planner) {
        <th pSortableColumn="eventOnEnter">
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'control-panel.zone-groups.eventOnEnter' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="eventOnEnter"></p-sortIcon>
              <p-columnFilter field="eventOnEnter"
                type="boolean"
                display="menu"
                [showApplyButton]="false"
              ></p-columnFilter>
            </div>
          </div>
        </th>
      }

      <!-- EVENT ON LEAVE -->
      @if (!planner) {
        <th pSortableColumn="eventOnLeave">
          <div class="d-flex align-items-center h-100">
            <!-- COLUMN TITLE -->
            <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
              {{ 'control-panel.zone-groups.eventOnLeave' | translate }}
            </div>
            <!-- COLUMN SORT && FILTER ICONS -->
            <div class="d-flex align-items-center h-100">
              <p-sortIcon field="eventOnLeave"></p-sortIcon>
              <p-columnFilter field="eventOnLeave"
                type="boolean"
                display="menu"
                [showApplyButton]="false"
              ></p-columnFilter>
            </div>
          </div>
        </th>
      }

      <!-- ACTIVE -->
      <!-- <th pSortableColumn="enabled">
      <div class="d-flex align-items-center h-100">

        <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
          {{ 'general.active' | translate }}
        </div>


        <div class="d-flex align-items-center h-100">
          <p-sortIcon field="enabled"></p-sortIcon>
          <p-columnFilter field="enabled"
            type="boolean"
            display="menu"
            [showApplyButton]="false"
          ></p-columnFilter>
        </div>

      </div>
    </th> -->

    <!-- ACTIVATED -->
    <th pSortableColumn="enabled">
      <div class="d-flex align-items-center h-100">
        <!-- COLUMN TITLE -->
        <div class="d-flex align-items-center align-items-center justify-content-center flex-fill h-100">
          {{ 'general.active' | translate }}
        </div>
        <!-- COLUMN SORT && FILTER ICONS -->
        <div class="d-flex align-items-center h-100">
          <p-sortIcon field="enabled"></p-sortIcon>
          <p-columnFilter field="enabled" type="boolean" display="menu"
            [showApplyButton]="false">
            <ng-template pTemplate="filter" let-filter="filterCallback">
              <p-select
                [options]="optionsdeleted"
                placeholder="{{ 'general.search' | translate }}"
                (onChange)="filter($event.value)">
                <ng-template let-option pTemplate="item">
                  <span [ngClass]="'p-ml-1 state-' + option.value">
                    {{ option.label }}
                  </span>
                </ng-template>
              </p-select>
            </ng-template>
          </p-columnFilter>
        </div>
      </div>
    </th>

  </tr>
</ng-template>

<!-- TABLE BODY -->
<ng-template pTemplate="body" let-zone>
  <tr class="p-selectable-row custom-rows" (dblclick)="editDialog(zone)">

    <!-- SELECT -->
    <td>
      <div class="d-flex justify-content-center">
        <p-tableCheckbox [value]="zone"></p-tableCheckbox>
      </div>
    </td>

    <!-- ID -->
    <td>
      <div class="d-flex justify-content-center">
        {{zone.id}}
      </div>
    </td>

    <!-- NAME -->
    <td>
      {{zone.name}}
    </td>

    <!-- TYPE -->
    <td>
      <div class="d-flex justify-content-center">
        {{zone.circular ? "Circular" : "Polygonal"}}
      </div>
    </td>

    <!-- EVENT ON ENTER -->
    @if (!planner) {
      <td class="p-text-center">
        <div class="d-flex justify-content-center align-items-center">
          <i class="pi"
          [ngClass]="{'true-icon pi-check-circle': zone.eventOnEnter, 'false-icon pi-times-circle': !zone.eventOnEnter}"></i>
        </div>
      </td>
    }

    <!-- EVENT ON LEAVE -->
    @if (!planner) {
      <td class="p-text-center">
        <div class="d-flex justify-content-center align-items-center">
          <i class="pi"
          [ngClass]="{'true-icon pi-check-circle': zone.eventOnLeave, 'false-icon pi-times-circle': !zone.eventOnLeave}"></i>
        </div>
      </td>
    }

    <!-- ACTIVE -->
    <td class="p-text-center">
      <div class="d-flex justify-content-center align-items-center">
        <i class="pi"
        [ngClass]="{'true-icon pi-check-circle': zone.enabled, 'false-icon pi-times-circle': !zone.enabled}"></i>
      </div>
    </td>
  </tr>
</ng-template>

<!-- TABLE EMPTY MESSAGE -->
<ng-template pTemplate="emptymessage">
  <tr>
    <td colspan="7" class="p-0">
      <div class="d-flex align-items-center justify-content-center h-100 p-5 custom-empty-message" i18n>
          {{ 'table.tableEmptyMessage' | translate }}!
        </div>
    </td>
  </tr>
</ng-template>

<!-- FOOTER -->
<ng-template pTemplate="footer">
  <tr>
    <td colspan="7" class="p-0">
      <div class="d-flex flex-row align-items-center p-3 gap-3">

        <!-- ADD ZONE BUTTON -->
        <app-table-add-button [text]=" 'control-panel.zone-groups.zone' | translate "
          (btnClick)="createZoneDialog()"
          [isDisabled]="!user.canManageZoneGroups"
        ></app-table-add-button>

        <!-- CHANGE STATUS BUTTON -->
        <app-table-change-status-button (btnClick)="changeStatus()"
          [isDisabled]="!user.canManageZoneGroups || selectedEntities.length === 0"
        ></app-table-change-status-button>

      </div>
    </td>
  </tr>
</ng-template>

</p-table>

<!-- CHANGE STATUS DIALOG  -->
@if (showStatusDialog) {
  <div>
    <app-change-status-dialog [items]=" 'control-panel.statusDialog.zones' | translate "
      [display]="true"
      [service]=zoneService
      [entitiesList]=selectedEntities
      (return)="refreshList($event)"
      (close)="closeStatusDialog($event)"
    ></app-change-status-dialog>
  </div>
}

<!-- ZONE FORM -->
<app-zone-form ></app-zone-form>
